import React from 'react';

//Composants
import Title from '../../components/Title/Title';
import ContentText from '../../components/content/content-text.jsx';
import SimpleTitle from '../../components/Title/SimpleTitle';
import Content from '../../components/content/content';
import ContentSlider from '../../components/content/content-slider';
import Skills from '../../components/Projects/Skills.jsx';

//Contenus
import binzegger from '../../assets/content/projets/binzegger.json';


const Binzegger = () => {

    return (
        <div className='projet'>
            <div class="bloc">
                <Title title={binzegger.title} variant={binzegger.variant} />
                <ContentText content={binzegger.description} />


                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    <Content content={binzegger.partie1} image={{thumb: binzegger.img1,hd: binzegger.img1grd}} alt={binzegger.alt1} cote={"left"} width={binzegger.width1} height={binzegger.height1}></Content>
                   
                    <ContentSlider content={binzegger.partie2} images={binzegger.slider2} cote={"right"}></ContentSlider>

                    <Content content={binzegger.partie3} image={{thumb: binzegger.imgpartie3,hd: binzegger.imgpartie3grd}} alt={binzegger.altpartie3} cote={"left"} width={binzegger.width3} height={binzegger.height3}></Content>
               
               
                    <div className='content-text'>
                        <ContentText content={binzegger.partie4} />
                    </div>

                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {binzegger.technologies.map((tech, index) => (
                    <Skills
                        image={tech.image}
                        alt={tech.alt}
                        competence={tech.name}
                        centered={tech.bool}
                    />
                ))}
                </div>
            </div>
            <div className='competences bloc'>
                <SimpleTitle title="Compétences et apprentissages critiques mobilisés" variant="purple" position="left" />
                <Content content={binzegger.competences} image={{thumb: binzegger.imgcompetences,hd: binzegger.imgcompetencesgrd}} alt={binzegger.altcompetencesgrd} cote={"left"} width={binzegger.widthcompetences} height={binzegger.heightcompetences} title="Illustration des compétences"></Content>
            </div>
            
        </div>
    );
};

export default Binzegger;